export default __webpack_public_path__ + "static/media/lato-italic.c2546c84.eot";